class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.initEventListeners();
    this.setHeaderCartIconAccessibility();
  }

  initEventListeners() {    
    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });    
    this.addCloseButtonListener();
  }

  addCloseButtonListener() {
    const closeButton = this.querySelector('.btn-close');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
     if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    const cartDrawer = this.querySelector('#CartDrawer');
    const backdrop = document.querySelector('.offcanvas-backdrop');
    if (backdrop) {    
        document.body.appendChild(backdrop);
      }
    
    if (!cartDrawer) return;

    setTimeout(() => {
      cartDrawer.classList.add('show');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    this.addCloseButtonListener();
  
  }

  close() {
    const cartDrawer = this.querySelector('#CartDrawer');  
    cartDrawer.classList.remove('show');    
    removeTrapFocus(this.activeElement); 
    const backdrop = document.querySelector('.offcanvas-backdrop');
    if (backdrop) {    
      backdrop.remove();  
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => { 
      this.addCloseButtonListener();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


function onKeyUpEscape(event) {
  if (event.code === 'Escape') {
    event.currentTarget.closest('details').removeAttribute('open');
  }
}


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
